import { useTranslation } from "react-i18next";
import { useEffect, useRef, useState } from "react";
import ContentLoader from "react-content-loader";
import Modal from "../../../../parts/modal-new";
import { videoCommentActions } from "../../../../parts/modals/thread-comments/comment-action-configs";
import { CommentsSection } from "../../../../parts/modals/thread-comments/comments-section";

const VideoCenterWatch = ({
  sharedUrl,
  locals,
  title,
  threadId,
  videoRecordId,
  athleteId,
  utcDate,
}) => {
  const { t } = useTranslation("athlete-portal");
  const webAppTheme = locals.activeUser.webAppTheme || "dark";

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [videoHTML, setVideoHTML] = useState(null);
  const bodyRef = useRef(null);

  useEffect(() => {
    const getEmbedBody = async () => {
      try {
        const { oembed } = await import("@loomhq/loom-embed");
        const res = await oembed(`https://www.loom.com/share/${sharedUrl}`);
        setVideoHTML(res.html);
      } catch (e) {
        console.log({ e });
        setError(true);
      }
      setLoading(false);
    };

    if (sharedUrl) {
      getEmbedBody();
    }
  }, [sharedUrl]);

  return (
    <Modal
      width="700px"
      title={title ? title : t("videoCenterWatch.watchLoom")}
      className={"watch-loom-modal"}
      toClear={["sharedUrl", "threadId", "videoRecordId", "utcDate"]}
    >
      {!loading ? (
        <div className="body" ref={bodyRef}>
          {error ? (
            <p className="font-bold">
              {t("videoCenterWatch.errorGettingVideo")}
            </p>
          ) : (
            <div>
              <div
                dangerouslySetInnerHTML={{ __html: videoHTML }}
                className="loom-video-container"
              ></div>
              <CommentsSection
                bodyRef={bodyRef}
                commentActions={videoCommentActions}
                commentParams={{
                  threadId,
                  videoRecordId,
                  receiverId: athleteId,
                  utcDate,
                }}
                locals={locals}
              />
            </div>
          )}
        </div>
      ) : (
        <VideoLoading webAppTheme={webAppTheme} />
      )}
    </Modal>
  );
};

export const VideoLoading = (props) => {
  const { webAppTheme } = props;

  const backgroundColor = webAppTheme === "dark" ? "#363C43" : "#F1F3F6";
  const foregroundColor = webAppTheme === "dark" ? "#40464D" : "#E0E4EA";

  return (
    <ContentLoader
      width={450}
      height={400}
      viewBox="0 0 450 400"
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      {...props}
    >
      <rect x="43" y="304" rx="4" ry="4" width="271" height="9" />
      <rect x="44" y="323" rx="3" ry="3" width="119" height="6" />
      <rect x="42" y="77" rx="10" ry="10" width="388" height="217" />
    </ContentLoader>
  );
};

export default VideoCenterWatch;
